import {
	HOVER_POI,
	LOAD_DISTRICT_DATA,
	LOAD_DISTRICT_DATA_BY_ID
} from "./constants";

const INITIAL_STATE = {
	data: [],
	poiItem: undefined,
	hoverId: undefined
};
export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case LOAD_DISTRICT_DATA:
			return { ...state, data: action.payload };
		case LOAD_DISTRICT_DATA_BY_ID: {
			const poi = state.data.filter(poi => poi.id === action.payload);
			return { ...state, poiItem: poi[0] };
		}
		case HOVER_POI: {
			return { ...state, hoverId: action.payload };
		}
		default:
			return state;
	}
};
